import mqtt from 'mqtt';
import root from './proto'
import {alpha_server_ws, rc_server_ws, alpha_server_mqtt, rc_server_mqtt} from './NetworkProp'
import axios from "axios";
import {Property} from '../system/global'

let message = root.cn.beepower.domain.message;
let msgCB = {};

export let MessageBroker;

export const WebSocketAPI = {
  propSet: (props) => {
    return {
      clientId: props.clientId,
      clean: true,
      keepalive: 60 * 5,
      username: props.username,
      password: props.password,
      reconnectPeriod: 60 * 1000, //重连间隔
      connectTimeout: 10 * 1000 //连接超时时间为30秒
    }
  },
  createConnection: (cb, wsProps) => {
    if (!wsProps) MessageBroker = mqtt.connect(alpha_server_ws.url, WebSocketAPI.propSet(alpha_server_ws));
    else MessageBroker = mqtt.connect(wsProps.url, wsProps);
    MessageBroker.on('connect', msgConnected);
    MessageBroker.on('message', msgArrived);
    MessageBroker.on('close', linkClosed);
    MessageBroker.on('disconnect', linkDisConnect);
    MessageBroker.on('offline', linkOffLine);
    MessageBroker.on('error', linkError);
    MessageBroker.on('packetsend', msgSend);
    MessageBroker.on('packetreceive', msgReceived);
    msgCB['init'] = cb;
  },
  SUB: (topic, callback) => {
    MessageBroker.subscribe(topic);
    msgCB[topic] = callback;
  },
  PUB: (topic, options) => {
    console.log("PUB topic:",topic," options:",options);
    let payload = new message.Payload();
    payload.clientId = options.clientId; // 设置clientId
    payload.messageId = options.messageId // 设置messageId
    payload.value = new Buffer(options.value); // 查询参数为payload的value对象
    let pBuffer = message.Payload.encode(payload).finish()
    MessageBroker.publish(topic, pBuffer);
  }
}

export const MqttAPI = {
  propSet: (props) => {
    return {
      clientId: props.clientId,
      clean: true,
      keepalive: 5 * 60,
      username: props.username,
      password: props.password,
      reconnectPeriod: 5 * 60 * 1000, //重连间隔
      connectTimeout: 5 * 60 * 1000 //连接超时时间为30秒
    }
  },
  createConnection: (cb, mqttProps) => {
    if (!mqttProps) MessageBroker = mqtt.connect(alpha_server_mqtt.url, MqttAPI.propSet(alpha_server_ws));
    else MessageBroker = mqtt.connect(mqttProps.url, mqttProps);
    MessageBroker.on('connect', msgConnected);
    MessageBroker.on('message', msgArrived);
    MessageBroker.on('close', linkClosed);
    MessageBroker.on('disconnect', linkDisConnect);
    MessageBroker.on('offline', linkOffLine);
    MessageBroker.on('error', linkError);
    MessageBroker.on('packetsend', msgSend);
    MessageBroker.on('packetreceive', msgReceived);
    msgCB['init'] = cb;
  },
  SUB: (topic, callback) => {
    MessageBroker.subscribe(topic);
    msgCB[topic] = callback;
  },
  PUB: (topic, options) => {
    let payload = new message.Payload();
    payload.clientId = options.clientId; // 设置clientId
    payload.messageId = options.messageId // 设置messageId
    payload.value = new Buffer(options.value); // 查询参数为payload的value对象
    let pBuffer = message.Payload.encode(payload).finish()
    MessageBroker.publish(topic, pBuffer);
  }
}

export const HttpAPI = {
  GET: (cb, url) => {

  },

  POST: (cb, url) => {

  }
}

const msgConnected = e => {
  console.log("mqtt服务器连接成功");
  msgCB['init'](true, e)
}
const msgArrived = (topic, payload) => {
  let msg = "",asynchronous = false;
  const payloadObj = message.Payload.decode(payload) // 第一层为payload对象
  // console.log(payloadObj);
  switch (payloadObj.payloadType) {
    case "cn.beepower.domain.message.Result" :
      if(payloadObj.url){
        asynchronous = true
        axios({
          method: 'get',
          url: payloadObj.url.replace(Property.PayloadURL,""),
          responseType:"arraybuffer"
        }).then(res=>{
          let dataString = byteToString(Buffer.from(res.data))
          msg = dataString.substr(dataString.indexOf("{"),dataString.length)
          msgCB[topic](msg);
        })
      }else {
        // console.log(message.Result.decode(payloadObj.value));
        msg = message.Result.decode(payloadObj.value).message
      }
      break;
    default :
      msg = byteToString(payloadObj.value)
      break;
  }
  console.log("msgArrived msg",msg );
  if(!asynchronous)msgCB[topic](msg);
}


const linkClosed = e => {
}
const linkDisConnect = e => {
}
const linkOffLine = e => {
}
const linkError = e => {
}
const msgSend = e => {
}
const msgReceived = e => {
}

function Utf8ArrayToStr(array) {
  var out, i, len, c;
  var char2, char3;

  out = "";
  len = array.length;
  i = 0;
  while (i < len) {
    c = array[i++];
    switch (c >> 4)
    {
      case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
      // 0xxxxxxx
      out += String.fromCharCode(c);
      break;
      case 12: case 13:
      // 110x xxxx   10xx xxxx
      char2 = array[i++];
      out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
      break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode(((c & 0x0F) << 12) |
          ((char2 & 0x3F) << 6) |
          ((char3 & 0x3F) << 0));
        break;
    }
  }
  return out;
}

function byteToString(arr) {
  if (typeof arr === 'string') return arr;
  let str = '',
    _arr = arr;
  for (let i = 0; i < _arr.length; i++) {
    let one = _arr[i].toString(2),
      v = one.match(/^1+?(?=0)/);
    if (v && one.length === 8) {
      let bytesLength = v[0].length;
      let store = _arr[i].toString(2).slice(7 - bytesLength);
      for (let st = 1; st < bytesLength; st++) {
        store += _arr[st + i].toString(2).slice(2);
      }
      str += String.fromCharCode(parseInt(store, 2));
      i += bytesLength - 1;
    } else {
      str += String.fromCharCode(_arr[i]);
    }
  }
  return str;
}
